import { General } from "../../siteManagement/general"
import { Grid } from "../core/components/grid"
import { Dialog,DialogAction,DialogProps } from "../core/components/dialog"
import { Helper } from "../core/util/helper"
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp";
import { HTTPService, HTTPServiceError, JsonResultClass } from "../core/util/httpManager";
import { Config } from "../core/config/config";
import { NotificationHelper } from "../core/util/notificationHelper";
import { AppHelper } from "../appHelper";
import { PageTitleProps } from "../core/components/pageTitle";
import React from "react";


export default class CRTemplateList extends React.Component<CRTemplateListProps, CRTemplateListState>{
    common = new AppHelper();
    gridOptions: any;
    fileSelectorRef: any;


    constructor(props) {
        super(props);
        this.common.init(this);
        this.initApp();
        General.Sheet.Manager.getTopMostSheet().setTitle(Helper.getTranslation("WebSMS.Report.Template"));
        this.gridOptions = this.createGridOptions();
        this.state = {
            templates: [],
            selectedItem: null,
            importDialogOpen: false,
            file:[]
        };
    }
    private initApp = async () => {
    }

    componentDidMount() {
        this.loadData();
    }
    loadData() {
        HTTPService.get('CRTemplate/GetTemplateList')
            .then((result) => {
                this.setState({ templates: result.Data });
            });
    }
    createGridOptions = (): kendo.ui.GridOptions => {
        const gridOptions: any = {
            filterable: true,
            selectable: "multiple",
            columns: [
                { field: "Title", title: Helper.getTranslation("WebSMS.Report.Template.Title"), reactTemplate: this.createLink },
                { field: "Tags", title: Helper.getTranslation("WebSMS.Report.Question.Tags") },
                { field: "Version", title: Helper.getTranslation("WebSMS.Report.Question.Version") }

            ]
        };
        return gridOptions;
    }
    openNewTemplateSheet = (params, e) => {
        e.preventDefault();
        const sheet = General.Sheet.Manager.createSheetWithUrl(`CRTemplate/Edit?Id=${params.ID}`);
    }

    createLink = (params) => {
        return <a href={`${Config.baseUrl}CRTemplate/Edit?Id=${params.ID}`} onClick={this.openNewTemplateSheet.bind(this, params)}>{params.Title}</a >;
    }

    handleSelectedItemChanged = (items) => {

        if (Array.isArray(items)) {
            this.setState({ selectedItem: items });
        }
        else if (items == null) {
            this.setState({ selectedItem: null });
        }
        else {
            this.setState({ selectedItem: [items] });
        }
    }

    getIds(items: CRTemplateListEntry[]): string[] {
        var ids = items.map(i => i.ID);
        return ids;
    }
    
    handleExport = async () => {

        var ids = this.getIds(this.state.selectedItem);
        const url = Config.baseUrl + "CRTemplate/Exportreport?Ids=" + ids;
        this.openInNewBrowserTab(url);
    }


    public openInNewBrowserTab = (url: string) => {
        const dummyLink = $("<a>").text("click me!").attr({ href: url, target: "_blank" });
        $("body").append(dummyLink);
        dummyLink[0].click();
        dummyLink.remove();
    }

    handleImport = () => {
        this.setState({ importDialogOpen: true });
    }

    handleImportFinished = () => {
        location.reload();
    }
    saveFileSelected = (e) => {
        this.setState({ file: e.target.files[0]})
    }
    upload = async () => {
        if (this.state.file !== null) {
            var formData = new FormData();
            formData.append("reportToImport", this.state.file);
            NotificationHelper.showInfoMessage(Helper.getTranslation("WebSMS.Reporting.ImportTemplates"),);
            HTTPService.post<JsonResultClass>("CRTemplate/ImportReport", formData)
                .then(result => {
                    if (result.Code === 1) {
                        NotificationHelper.showErrorMessage(result.Message);
                    } else if (result.Code == undefined) {
                        NotificationHelper.showErrorMessage(Helper.getTranslation("WebSMS.Reporting.ErrorImportingTemplates"));
                    } else {
                        this.loadData();
                    }
                });
        }
        this.fileSelectorRef.value = "";
        this.setState({ importDialogOpen: false, file: [] });
        
    }
    renderGrid = () => {
        const dialogprops: DialogProps = {
            title: Helper.getTranslation("WebSMS.Reporting.ImportTemplates"),
            width: 450,
            actions: [
                {
                    label: Config.translations.ok,
                    action: () => { this.upload() }
                },
                {
                    label: Config.translations.cancel,
                    action: () => {
                        this.fileSelectorRef.value = "";
                        this.setState({ importDialogOpen: false, file: [] });
                    }
                }
            ],
            afterClose: () => { }
        };
        let dialog = <Dialog {...dialogprops} open={this.state.importDialogOpen}>
            <div>
                <label style={{ color: "red" }}>{Helper.getTranslation("WebSMS.Reporting.ImportWarning")}</label>
                <ul style={{ padding: "5px 20px" }}>
                    <input type="file" accept=".zip" ref={(ref) => this.fileSelectorRef=ref} onChange={this.saveFileSelected} />
                </ul>
            </div>
        </Dialog>
        return (

                <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                    {dialog}
                    {this.state.templates && this.state.templates.length > 0 ? 
                        <Grid id="CRTemplateList" data={this.state.templates} options={this.gridOptions} 
                              onSelectionChanged={this.handleSelectedItemChanged} /> : null}
                </div>
        )
    }
 


    render = () => {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: () => { } });
        const titleProps: PageTitleProps = {
            title: "",
            value: "",
            locked: false,
            lockInfo: ""
        };
        return <CommonApp {...props} titleProps={titleProps} />;
    }
};

export interface CRTemplateListState {
    templates: CRTemplateListEntry[];
    selectedItem: any;
    importDialogOpen: boolean;
    file: any;
}
export interface CRTemplateListEntry {
    ID: string;
    Tags: string;
    Title: string;
    Version: number;
}
export interface CRTemplateListProps extends AppBaseProps {

}



